import React, { useState } from 'react';
import classNames from 'classnames';

import { FormattedMessageWrappedInSpan, FormattedPrice } from '../../../components/misc';
import { TextButton } from '../../../components/misc/Buttons';

import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import CircularProgress from '@material-ui/core/CircularProgress';

import environment from '../../../environment';
import ApplyOrderCouponMutation from '../../../mutations/ApplyOrderCouponMutation';
import RemoveOrderCouponMutation from '../../../mutations/RemoveOrderCouponMutation';

import withRequestHandler from '../../hoc/withRequestHandler';


const CartCouponItem = (props) => {
  
  let initResult = props.bill.coupon ? true : false;
  let initCouponVat = props.bill.coupon ? props.bill.coupon.vat : null;
  let initCoupon = props.bill.coupon ? props.bill.coupon.code : '';
  let billAmount = props.bill.coupon ? -Math.abs(props.bill.coupon.brutto.amount) : 0;
  let billCurrency = props.bill.coupon ? props.bill.coupon.brutto.currency : "EUR";

  const ENTER_KEY = 'Enter';

  const [expanded, setExpanded] = useState(initResult);
  const [couponVat, setCouponVat] = useState(initCouponVat);
  const [couponValue, setCouponValue] = useState(initCoupon);
  const [showResult, setShowResult] = useState(initResult);
  const [showSpinner, setShowSpinner] = useState(false);
  const [showCouponError, setShowCouponError] = useState(false);
  const [demoPrice, setDemoPrice] = useState({amount: billAmount, currency: billCurrency});

  const handleClickExpand = () => {
    setExpanded(true);
  };

  const handleCouponChange = event => {
    setCouponValue(event.target.value);
  };
  
  const handleClickApplyCoupon = () => {
    if (couponValue === '') {
      setShowCouponError(true);
    } else {
      setShowSpinner(true);

      handleCouponApply();
    }
  };

  const handleCouponApply = () => {
    ApplyOrderCouponMutation.commit(
      environment,
      couponValue,
      props.orderId,
      (errorMsg, cart) => {
        if (!errorMsg) {
          setDemoPrice({amount: -Math.abs(cart.order.bill.coupon.brutto.amount), currency: cart.order.bill.coupon.brutto.currency});
          setCouponVat(cart.order.bill.coupon.vat);
          setShowSpinner(false);
          setShowResult(true);
          setShowCouponError(false);
          props.onCouponChanged(cart);
        } else {
          setShowResult(true);
          setShowSpinner(false);
          setShowCouponError(true); 
        }
      }
    );
  };

  const handleClickRemoveCoupon = () => {
    setShowSpinner(true);
    handleCouponRemove();
  };

  const handleCouponRemove = () => {
    RemoveOrderCouponMutation.commit(
      environment,
      props.orderId,
      (errorMsg, cart) => {
        if (!errorMsg) {
          setCouponValue('');
          setShowResult(false);
          setShowSpinner(false);
          setShowCouponError(false);
          props.onCouponChanged(cart);
        } else {
          setShowSpinner(false);
          setShowResult(true);
          setShowCouponError(true);
        }
      }
    );
  }

  const handleKeypress = (event) => {
    if (event.key === ENTER_KEY) {
      handleClickApplyCoupon();
    }
  };

  return (
    <div className="cart-coupon-outer-container">
        {showSpinner && (
          <div className="cart-coupon-inner-container">
            <div className="cart-coupon-spinner">
              <CircularProgress />
            </div>
          </div>
        )}
        {!showSpinner && !expanded && (
          <div className="expand-cart-coupon-code" onClick={handleClickExpand}>
            <FormattedMessageWrappedInSpan id="cartCoupon.applyCouponCode" defaultMessage="+ If you have a coupon click to apply it." />
          </div>

        )}
        {!showSpinner && expanded && (
          <div className={classNames({'cart-coupon-inner-container': !showResult}, {'cart-coupon-result-container': showResult})}>

            <div className="cart-coupon-code-field">
              <TextField
                id="coupon-input"
                label="Coupon Code"
                margin="normal"
                autoFocus={!showResult}
                disabled={showResult && !showCouponError}
                error={showCouponError}
                value={couponValue}
                onChange={handleCouponChange}
                onKeyPress={handleKeypress}
                InputProps={{
                  endAdornment: (
                    <InputAdornment className="cart-coupon-apply-adornment" position="start">
                      {(showResult && !showCouponError) ? (
                        <TextButton
                          hasFullWidth={false}
                          onClick={handleClickRemoveCoupon}
                          leftLabel={
                            <FormattedMessageWrappedInSpan
                              id="cartCouponItem.remove"
                              defaultMessage="Remove"
                            />
                          }
                        />
                      ) : (
                        <TextButton
                          hasFullWidth={false}
                          onClick={handleClickApplyCoupon}
                          leftLabel={
                            <FormattedMessageWrappedInSpan
                              id="cartCouponItem.apply"
                              defaultMessage="Apply"
                            />
                          }
                        />
                      )}

                    </InputAdornment>
                  ),
                }}
              />
            </div>

            {showResult && !showCouponError && (
              <div className="cart-coupon-code-value-container cart-coupon-code-value">
                <FormattedMessageWrappedInSpan id="cartCoupon.title" defaultMessage="Value" />
                <FormattedPrice price={demoPrice} />
              </div>
            )}
            {showResult && showCouponError && (
              <div className="cart-coupon-code-error-container cart-coupon-code-error">
                <FormattedMessageWrappedInSpan id="cartCoupon.error" defaultMessage="No valid coupon found." />
              </div>
            )}
          </div>
        )}
        {!showSpinner && expanded && showResult && !showCouponError && (couponVat !== null) && (
          <div className="cart-coupon-footer">
            <div className="cart-coupon-footer-action-container">
                <p className="cart-coupon-vat">
                  <FormattedMessageWrappedInSpan
                    id="cartItem.vat"
                    defaultMessage="VAT: {vat}%"
                    values={{ vat: couponVat }}
                  />
                </p>
            </div>
          </div>
        )}
  </div>
  );
}

export { CartCouponItem };

export default withRequestHandler(CartCouponItem);
